/**
 * Created by pratik.panchal on 18-09-2018.
 */
import { createHashHistory } from "history";
export default createHashHistory();